import React, { useRef } from "react";
import PropTypes from "prop-types";
import { InputNumber, SelectPicker } from "rsuite";
import deleteIcon from "../../../assets/img/delete.svg";

const losTypes = [
  { label: "Minimum length of stay", value: "1" },
  { label: "Maximum length of stay", value: "2" },
  { label: "Range", value: "3" },
];

/**
 * LengthOfStaySection - Length of stay section with type selector and input fields
 */
function LengthOfStaySection({
  losType = "1",
  minLengthOfStay = null,
  maxLengthOfStay = null,
  onLosTypeChange,
  onMinMaxChange,
  onRangeChange,
  onRemove,
  hasError = false,
}) {
  const losTypePopUpRef = useRef(null);

  const renderInput = () => {
    if (losType === "1") {
      return (
        <InputNumber
          value={minLengthOfStay}
          min={1}
          max={28}
          onChange={(value) => onMinMaxChange(value, losType)}
          placeholder={""}
          block
        />
      );
    } else if (losType === "2") {
      return (
        <InputNumber
          value={maxLengthOfStay}
          min={1}
          max={28}
          onChange={(value) => onMinMaxChange(value, losType)}
          placeholder={""}
          block
        />
      );
    } else if (losType === "3") {
      return (
        <div className="los-lt-range-inputs">
          <div className={hasError ? "input-error" : ""}>
            <InputNumber
              value={minLengthOfStay}
              min={1}
              max={28}
              onChange={(value) => onRangeChange(value, "min")}
              placeholder={""}
              block
            />
          </div>
          <div className="los-lt-range-to">to</div>
          <div className={hasError ? "input-error" : ""}>
            <InputNumber
              value={maxLengthOfStay}
              min={1}
              max={28}
              onChange={(value) => onRangeChange(value, "max")}
              placeholder={""}
              block
            />
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="tc-section condition-form-section">
      <div className="condition-row">
        <span className="condition-label">Length of Stay</span>
        <div className="condition-input-wrapper">
          <SelectPicker
            value={losType}
            onChange={onLosTypeChange}
            placeholder="Choose an option"
            data={losTypes}
            block
            container={() => losTypePopUpRef.current}
            cleanable={false}
            searchable={false}
          />
          <div className="position-relative" ref={losTypePopUpRef} />
          <div
            className={`los-lt-input ${
              losType === "3" ? "los-lt-input-range" : ""
            }`}
          >
            {renderInput()}
          </div>
        </div>
        <button
          type="button"
          className="remove-condition-btn"
          onClick={onRemove}
        >
          <img src={deleteIcon} alt="Delete" className="delete-icon" />
        </button>
      </div>
    </div>
  );
}

LengthOfStaySection.propTypes = {
  losType: PropTypes.string,
  minLengthOfStay: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxLengthOfStay: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onLosTypeChange: PropTypes.func.isRequired,
  onMinMaxChange: PropTypes.func.isRequired,
  onRangeChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
};

export default LengthOfStaySection;
